import { render } from "./login.vue?vue&type=template&id=61cae392"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./login.vue?vue&type=custom&index=0&blockType=i18n&lang=json5"
if (typeof block0 === 'function') block0(script)
import block1 from "./login.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__